import React from "react";
import { Button, Divider, FormGroup, FormLabel, TextField } from '@material-ui/core';
import styles from ".//CreateCarrierDialog.module.css";
import "./ManageCompanyForm.css"
import {CANCEL, SAVE} from "../../global/constants";
import {ENABLE_COMPANY_CHECKBOX_LABEL, getDisplayLabel} from './constants';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Utils from "../../Utils/Utils";
import {
    CHILD_ROLE_MAP,
    PARENT_ROLE_MAP,
    ROLE_DEPTH_AND_ORDER, SELECT_COMPANY_SERVICES,
} from '../ManageUsers/constants';


class ManageCompanyForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {

      companyId: this.getValue('companyId'),
      name: this.getValue('name'),
      enabled: this.getValue('enabled'),
      status: this.getValue('status'),
      createdAt: this.getValue('createdAt'),
      authorities: this.getValue('authorities') || [],
      saved: false,
      requiredList: [
        'name',
        'authorities',
      ],
      previousCompanyNames: this.getValue('companyNames'),
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',

    };
  }

  componentDidMount() {
      const authority = this.getValue('authorities') || []
      const newAuthorities = authority.map(item => item.authority);
      this.setState({ authorities: newAuthorities });

  }


  checkName = () => {
    return (
      this.props.editingCompany?.name?.toLowerCase() !==
        this.state.name?.toLowerCase() &&
      this.state.previousCompanyNames.includes(this.state.name?.toLowerCase())
    );
  };

    checkSave = () => {
        let hasEmpty = false;

        this.state.requiredList.forEach((requiredField) => {
            const value = this.state[requiredField];
            if (
                value === '' ||
                value === null ||
                value === undefined ||
                (Array.isArray(value) && value.length === 0)
            ) {
                hasEmpty = true;
            }
        });

        return hasEmpty || this.checkName();
    };

    getValue = (key) => {
        if (key === 'companyNames')
            return this.props.companies?.map((company) => company.name?.toLowerCase());

        if (this.props.addingCompany) return '';

        return this.props.editingCompany[key];
    };


    handleChange = (e) => {
        this.setState({
          [e.target.name]: e.target.value,
        });
    };

  getChecked = (role) => {
        return this.state.authorities.includes(role)
  }

  selectAuthority = (role) => {

        let newAuthority = new Set(this.state.authorities)

        const updateChild = (isDelete, role) => {
            if (isDelete) {
                if (PARENT_ROLE_MAP[role]) {
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.delete(child)
                    })
                }
                if (CHILD_ROLE_MAP[role]) {
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        let hasChild = false
                        PARENT_ROLE_MAP[parent].forEach(child => {
                            if (newAuthority.has(child)) {
                                hasChild = true
                            }
                        })
                        if (!hasChild) {
                            newAuthority.delete(parent)
                        }
                    })
                }
            } else {
                if (PARENT_ROLE_MAP[role]) {
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.add(child)
                    })
                }
                if (CHILD_ROLE_MAP[role]) {
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        newAuthority.add(parent)
                    })
                }
            }
        }
        if (!this.state.authorities.includes(role)) {
            this.props.allRoles.forEach(roleInAllRole => {
                if (role === roleInAllRole) {
                    newAuthority.add(roleInAllRole)
                    updateChild(false, roleInAllRole)
                }
                if (this.state.authorities.includes(roleInAllRole)) {
                    newAuthority.add(roleInAllRole)
                }
            });
        } else {
            newAuthority.delete(role)
            updateChild(true, role)
        }

        this.setState({
            authorities: Array.from(newAuthority)
        })
    }

  getSpace = (role) => {
        let spaces = []
        for (let index = 0; index < ROLE_DEPTH_AND_ORDER[role]; index++) {
            spaces.push("space")
        }
        return spaces.map(space => {
            return <div className="authority-space"/>
        })
  }

  getLabel = (label) => {
        let words = label.split('_')
        words.splice(0, 1)
        words = words.map(word => {
            return word[0].toUpperCase() + word.slice(1).toLowerCase()
        })
        return words.join(' ')
  }

  render() {

    return (
      <div className={styles.rowCarrier} style={{ marginTop: '24px' }}>

        <div className={styles.innerBox}>
          <div className={styles.rowSpec}>
            <TextField
              required={this.state.requiredList.includes('name')}
              className={styles.formTwoInput}
              variant="outlined"
              name="name"
              onChange={this.handleChange}
              value={this.state.name}
              label="Company Name"
              InputLabelProps={{ shrink: true }}
            />
          </div>


          {!this.props.addingCompany && (
              <>
              <Divider
                  style={{
                    marginBottom: '24px',
                    marginTop: '24px',
                    height: '1px',
                    color: '#f4f4f4',
                  }}
              />
                <div className={styles.rowSpec}>
                  <Autocomplete
                      options={['Active','Hold',"Closed"]}
                      getOptionLabel={(option) =>
                          option.charAt(0).toUpperCase() + option.slice(1)
                      }
                      className={styles.formThreeInput}
                      name="status"
                      value={this.state.status}
                      onChange={(event, value) => {
                        this.setState({
                          status: value ? value.toLowerCase() : '',
                        });
                      }}
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              label="Company Status"
                              required
                              InputLabelProps={{shrink: true}}
                              variant="outlined"
                              name="status"
                          />
                      )}
                  />

                  <TextField
                      className={styles.formThreeInput}
                      variant="outlined"
                      name="createdAt"
                      disabled={true}
                      onChange={this.handleChange}
                      value={Utils.formatTodayDate(new Date(this.state.createdAt))}
                      label="Registration Date"
                      InputLabelProps={{ shrink: true }}
                  />

                  <div className={styles.formThreeInput}></div>

                </div>

                <div className={styles.rowSpec}>
                  <FormControlLabel
                      style={{margin: 10, width: 225, whiteSpace: 'nowrap'}}
                      control={
                        <Checkbox
                            checked={this.state.enabled}
                            onChange={(e) =>
                                this.setState({enabled: e.target.checked})
                            }
                            disabled
                        />
                      }
                      label={ENABLE_COMPANY_CHECKBOX_LABEL}
                  />
                </div>
              </>
              )}


              <Divider className="divider" style={{marginTop:'16px',marginBottom:'16px'}} />


              <div className="register-new-user-role-box">
              <FormLabel component="legend">{SELECT_COMPANY_SERVICES}</FormLabel>
              <FormGroup>
                {this.props.allRoles.map((role, i) => {
                  return (
                    <div className="authority-box">
                      {this.getSpace(role)}
                      <Checkbox

                        checked={this.getChecked(role)}
                        onChange={() => this.selectAuthority(role)}
                        name="authority"
                        color="primary"
                      />
                      <div>
                          {getDisplayLabel(this.getLabel(role))}
                      </div>
                    </div>
                  );
                })}
              </FormGroup>
            </div>

              <div className="save-cancel-buttons">
                <Button variant="contained" onClick={this.props.handleClose}>
                  {CANCEL}
                </Button>
                <div className="save-spacing"/>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.setState({saved: true});
                      this.props.handleSave(this.props.addingCompany, this.state);
                    }}
                    disabled={this.checkSave()}
                >
                  {SAVE}
                </Button>
              </div>

        </div>
      </div>
    );
  }
}

export default ManageCompanyForm